import { useIntl } from "react-intl";
import { Button } from "src/design-system/components/Button/Button";
import messages from "./CombinedPicker.messages";

type Props = {
  onClickButton: () => void;
};

export default function DatePopoutFooter({ onClickButton }: Props) {
  const intl = useIntl();

  return (
    <div className="fixed bottom-0 left-0 z-10 w-full border-t border-t-border bg-surface p-4">
      <Button size="large" className="w-full" onPress={onClickButton}>
        {intl.formatMessage(messages.doneButton)}
      </Button>
    </div>
  );
}
